import { MASTERS_SYNC_COOLDOWN_MS } from '../../sync/core/masterSyncPolicyConstants';

let catalogHydratedAt = 0;

export function markCatalogHydrated(): void {
  catalogHydratedAt = Date.now();
}

export function wasCatalogHydratedRecently(): boolean {
  if (catalogHydratedAt <= 0) return false;
  return Date.now() - catalogHydratedAt < MASTERS_SYNC_COOLDOWN_MS;
}

export function resetCatalogHydrationState(): void {
  catalogHydratedAt = 0;
}
